import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Country } from '../models/country.model';
import { map, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CountryService {

  private apiUrl = `${environment.sgcApi}`;
  private countryRoute = 'country';

  constructor(private httpClient: HttpClient) { }

  getCountries() : Observable<Country[]> {
    let endpoint = `${this.apiUrl}${this.countryRoute}`;
    return this.httpClient.get<Country[]>(endpoint)
      .pipe(map((data) => data));
  }
}
